export default __webpack_public_path__ + "static/media/02_Touch.1e712c24.jpg";